import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DistributionsService } from 'src/app/services/distributions.service';

@Component({
  selector: 'app-distribution-edit-tracking',
  templateUrl: './distribution-edit-tracking.component.html',
  styleUrls: ['./distribution-edit-tracking.component.scss']
})
export class DistributionEditTrackingComponent {

  isMultiple = false;
  dataArray: any[] = [];
  data: any = {};
  showPaqueteriaSelect = false;
  contLocal: number = 0;

  constructor(
    private distService : DistributionsService,
    public dialogRef: MatDialogRef<DistributionEditTrackingComponent>, 
    @Inject(MAT_DIALOG_DATA) public inputData: any) {

      if (Array.isArray(inputData.newArray)) {
        this.isMultiple = true;
        this.dataArray = inputData.newArray;
        this.data = { 
          estatus: null, 
          fecha_entrega: null,
          paqueteria: null,
          tracking_number: null
        };

        //Para saber si todas las que seleccionó tienen paqueteria local
        /* inputData.newArray.forEach((item: any) => {
          if(item.paqueteria == 'LOCAL'){
            this.contLocal++;
          }
        });

        if(inputData.newArray.length == this.contLocal){
          this.showPaqueteriaSelect = true;
          this.data.paqueteria = 'LOCAL'
        } */

      } else {
        this.data = inputData.newArray;
      }
    }


    ngOnInit() {
      /* if (this.data.paqueteria === 'LOCAL') {
        this.showPaqueteriaSelect = true;
      } */
    }

  editTracking(row: any){

    let newObj = {};

    if (this.isMultiple) {
      this.dataArray.forEach(item => {
        item.estatus = this.data.estatus == null ? item.estatus : this.data.estatus;
        item.fecha_entrega = this.data.fecha_entrega == null ? item.fecha_entrega : this.data.fecha_entrega;
        item.paqueteria = this.data.paqueteria == null ? item.paqueteria : this.data.paqueteria;
        item.tracking_number = this.data.tracking_number == null ? item.tracking_number : this.data.tracking_number;
      });

      newObj = this.dataArray;

    } else {
      newObj = this.data
    }

    this.distService.editDistTracking(newObj).subscribe(
      (result : any) => {
        if(result.message == "Success") {
          
          this.dialogRef.close({saved: 1});

        }
      },
      (err : any) => {
        console.log(err);
      }
    );

  }


}
